import { CobaltActionBar } from '@cae/cobalt-react/components/action-bar';
import { CobaltButton } from '@cae/cobalt-react/components/button';
import { CobaltModal } from '@cae/cobalt-react/components/modal';
import { MediaQuery } from '@cae/cobalt-react/enums';
import { useMediaQuery } from '@cae/cobalt-react/hooks';
import { DISCIPLINE_DISPLAY_NAME_MAP } from '@features/instructors/utils/discipline.utils';
import * as React from 'react';

import type { InstructorActionFeedbackModalProps } from './InstructorActionFeedbackModal.types';

import { InstructorsTile } from '../../../tile/InstructorsTile';
import styles from './InstructorActionFeedbackModal.module.css';
import {
  getBadge,
  getSectionMessage,
} from './InstructorActionFeedbackModal.utils';

const InstructorActionFeedbackModal = React.memo(
  ({
    isOpen,
    onClose,
    status,
    programId,
    disciplineName,
    action,
    instructor,
  }: Readonly<InstructorActionFeedbackModalProps>): React.ReactElement => {
    const isMobile = useMediaQuery(MediaQuery.Mobile);

    const heading: string =
      action === 'Revoke' ? 'Revocation request' : 'Approval request';

    return (
      <CobaltModal
        isOpen={isOpen}
        size={isMobile ? 'small' : 'medium'}
        title={heading}
        showCloseButton={true}
        onClose={onClose}
        actionBar={
          <CobaltActionBar
            position="right"
            primaryButton={
              <CobaltButton variant="secondary" onClick={onClose}>
                Done
              </CobaltButton>
            }
          />
        }
      >
        <div
          className={styles.modalContainer}
          data-testid="action-feedback-modal-content"
        >
          {getSectionMessage(action, status, instructor.displayName)}
          {action === 'Approve' && status === 'success' && (
            <div className={styles.nextStepsContainer}>
              <h3 className="heading-01">What to expect next...</h3>
              <p className={`body-02 ${styles.nextSteps}`}>
                Please upload your Check Airman packet by clicking on upload
                approval letter.
              </p>
            </div>
          )}
          <h2 className={`heading-01 ${styles.disciplineTitle}`}>
            {DISCIPLINE_DISPLAY_NAME_MAP[disciplineName] ?? disciplineName}
          </h2>
          <InstructorsTile
            instructor={instructor}
            programOverride={programId}
            badge={getBadge(action)}
          />
        </div>
      </CobaltModal>
    );
  }
);

InstructorActionFeedbackModal.displayName = 'InstructorActionFeedbackModal';
export { InstructorActionFeedbackModal };
